import {withInstall} from '../../utils';
import Component from './src/uni-comp.vue';

export const UniComp = withInstall(Component);
export default UniComp;
